import { render, staticRenderFns } from "./WaiterJudgedTab.vue?vue&type=template&id=143f4412&scoped=true&lang=pug"
import script from "./WaiterJudgedTab.vue?vue&type=script&lang=ts"
export * from "./WaiterJudgedTab.vue?vue&type=script&lang=ts"
import style0 from "./WaiterJudgedTab.vue?vue&type=style&index=0&id=143f4412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f4412",
  null
  
)

export default component.exports